import axiosWithAuth from '../../utils/axiosWithAuth';
import { CreateSupplierData, UpdateSupplierData, SupplierQueryParams } from '../../types/supplier';

const API_BASE_URL = '/suppliers';

export const supplierAPI = {
  // Create a new supplier
  createSupplier: async (data: CreateSupplierData) => {
    const response = await axiosWithAuth.post(API_BASE_URL, data);
    return response.data;
  },

  // Get all suppliers with pagination and filtering
  getSuppliers: async (params: SupplierQueryParams = {}) => {
    console.log('🚀 Making API call to:', `${axiosWithAuth.defaults.baseURL}${API_BASE_URL}`, 'with params:', params);
    const response = await axiosWithAuth.get(API_BASE_URL, { params });
    console.log('🚀 Raw API response:', response);
    console.log('🚀 Response data:', response.data);
    return response.data;
  },

  // Get active suppliers for dropdown
  getSuppliersDropdown: async (search?: string) => {
    const response = await axiosWithAuth.get(`${API_BASE_URL}/dropdown`, {
      params: search ? { search } : undefined
    });
    return response.data;
  },

  // Get a specific supplier by UUID
  getSupplier: async (uuid: string) => {
    const response = await axiosWithAuth.get(`${API_BASE_URL}/${uuid}`);
    return response.data;
  },

  // Update a supplier
  updateSupplier: async (uuid: string, data: UpdateSupplierData) => {
    const response = await axiosWithAuth.put(`${API_BASE_URL}/${uuid}`, data);
    return response.data;
  },

  // Delete a supplier (soft delete)
  deleteSupplier: async (uuid: string) => {
    const response = await axiosWithAuth.delete(`${API_BASE_URL}/${uuid}`);
    return response.data;
  },

  // Restore a deleted supplier
  restoreSupplier: async (uuid: string) => {
    const response = await axiosWithAuth.post(`${API_BASE_URL}/${uuid}/restore`);
    return response.data;
  },

  // Check supplier usage in inventory
  checkSupplierUsage: async (uuid: string) => {
    const response = await axiosWithAuth.get(`${API_BASE_URL}/${uuid}/usage`);
    return response.data;
  },
};